import { get } from 'lodash'

import render from './render'

export default {
  name: 'Buttons',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    id() {
      return get(this.value, 'id')
    }
  },

  render
}
